// Общие настройки Chart.js для графиков дашборда.
import { formatCompact, toPercent } from "../dashboard-utils";

/** Палитра категорий — та же, что у графиков обращений, чтобы дашборд выглядел единообразно. */
export const CHART_PALETTE = [
  "#4F46E5",
  "#22C55E",
  "#F59E0B",
  "#EF4444",
  "#06B6D4",
  "#A855F7",
  "#EC4899",
  "#84CC16",
  "#F97316",
  "#0EA5E9",
];
export const COLOR_OTHER = "#94A3B8";

const sum = (values: number[]) => values.reduce((a, b) => a + (Number(b) || 0), 0);

/**
 * Круговой/кольцевой график: в легенде «Название — значение», в подсказке ещё и доля в %.
 * `format` форматирует значение (число, деньги).
 */
export const pieOptions = (format: (v: number) => string) => ({
  plugins: {
    legend: {
      position: "bottom" as const,
      labels: {
        boxWidth: 12,
        boxHeight: 12,
        padding: 12,
        generateLabels: (chart: any) => {
          const ds = chart.data.datasets?.[0];
          if (!ds) return [];
          return chart.data.labels.map((label: string, i: number) => ({
            text: `${label} — ${format(ds.data[i])}`,
            fillStyle: ds.backgroundColor[i],
            strokeStyle: ds.backgroundColor[i],
            hidden: !chart.getDataVisibility(i),
            index: i,
          }));
        },
      },
    },
    tooltip: {
      callbacks: {
        label: (item: any) => {
          const total = sum(item.dataset.data);
          return ` ${format(item.raw)} (${toPercent(item.raw, total)}%)`;
        },
      },
    },
  },
});

/** Столбчатый график: компактные подписи оси (1,2 млн), полные значения в подсказке. */
export const barOptions = (format: (v: number) => string, { horizontal = false } = {}) => {
  const valueAxis = {
    beginAtZero: true,
    grid: { color: "rgba(148, 163, 184, 0.2)" },
    ticks: { precision: 0, callback: (v: any) => formatCompact(v) },
  };
  const categoryAxis = { grid: { display: false } };

  return {
    indexAxis: horizontal ? ("y" as const) : ("x" as const),
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: { label: (item: any) => ` ${format(item.raw)}` },
      },
    },
    scales: horizontal ? { x: valueAxis, y: categoryAxis } : { x: categoryAxis, y: valueAxis },
  };
};
